<template>
  <div>
    <b-card title="جستجو">
      <b-row>
        <div class="col-md-4">
          <b-form-group label="درگاه">
            <b-form-select :options="gateways" v-model="gid"> </b-form-select>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="از تاریخ">
            <date-picker clearable v-model="DateFrom"></date-picker>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="تا تاریخ">
            <date-picker clearable v-model="DateTo"></date-picker>
          </b-form-group>
        </div>
      </b-row>
      <b-row>
        <div class="col-md-4">
          <b-form-group label="چهار رقم آخر کارت">
            <b-form-input
              id="title-1"
              required
              v-model="CardNumber"
              placeholder="چهار رقم آخر کارت "
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="کد رهگیری پرداخت">
            <b-form-input
              id="title-1"
              required
              v-model="SaleOrderId"
              placeholder="کد رهگیری پرداخت "
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="فقط نمایش تراکنش های موفق">
            <b-form-checkbox v-model="is_verify">بلی</b-form-checkbox>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-button ref="filter_btn" variant="success" @click="LoadData(1)"
            >فیلتر</b-button
          >
        </div>
      </b-row>
    </b-card>
    <b-card>
      <!-- <div>
        <b-button :variant="!ShowFilter?'success':'warning'" @click="ShowFilter = !ShowFilter">فیلتر</b-button>
      </div>
      <div v-if="ShowFilter">فیلتر</div>-->
      <b-skeleton-table
        v-if="!dataLoaded"
        :rows="10"
        :columns="7"
        :table-props="{ bordered: true, striped: true }"
      ></b-skeleton-table>
      <div v-if="dataLoaded">
        <b-table
        responsive
          striped
          hover
          show-empty
          empty-text="آیتمی جهت نمایش وجود ندارد"
          :fields="fields"
          :items="transactions"
        >
          <template v-slot:cell(more_data)="row">
            <b-link v-on:click="ShowDetail(row.item.id)">اطلاعات تراکنش</b-link>
          </template>
          <template v-slot:cell(is_verify)="row">{{
            row.item.is_verify == 1 ? "موفق" : "ناموفق"
          }}</template>
          <template v-slot:cell(cost)="row">{{
            Number(row.item.cost).toLocaleString()
          }}</template>
          <template v-slot:cell(verify_date)="row">{{
            row.item.verify_date == null ? "" : getDate(row.item.verify_date)
          }}</template>
        </b-table>
        <b-button-group>
          <b-button @click="LoadData(1)"
            ><i class="flaticon2-next"></i
          ></b-button>
          <b-button
            v-for="page in pages"
            v-bind:key="page"
            @click="LoadData(page)"
            :variant="page == current_page ? 'success' : 'default'"
            >{{ page }}</b-button
          >
          <b-button @click="LoadData(page_count)"
            ><i class="flaticon2-back"></i
          ></b-button>
        </b-button-group>
      </div>
    </b-card>

    <b-modal id="transaction-details" hide-footer>
      <template v-slot:modal-title>اطلاعات تراکنش</template>
      <div class="d-block">
        <b-form-group label="وضعیت:">
          <div class="form-control">
            {{ trDetail.is_verify == 1 ? "تایید شده" : "تایید نشده" }}
          </div>
        </b-form-group>
        <b-form-group label="مبلغ:">
          <div class="form-control">
            {{ Number(trDetail.cost).toLocaleString() }}
          </div>
        </b-form-group>
        <b-form-group label="تاریخ:">
          <div class="form-control">{{ trDetail.persian_date }}</div>
        </b-form-group>
        <b-form-group label="ساعت:">
          <div class="form-control">
            {{
              new Date(trDetail.verify_date).getHours() +
              ":" +
              new Date(trDetail.verify_date).getMinutes()
            }}
          </div>
        </b-form-group>
        <b-form-group label="آدرس درخواست دهنده:">
          <div class="form-control">
            <b-img
              :src="
                'media/svg/flags/' +
                trDetail.location.countryCode.toLowerCase() +
                '.svg'
              "
              height="20px"
            ></b-img>
            {{ trDetail.ip }}
          </div>
        </b-form-group>
        <b-form-group label="کد رهگیری پرداخت:">
          <div class="form-control">{{ trDetail.sale_reference_id }}</div>
        </b-form-group>
        <b-form-group label="شماره کارت:">
          <div class="form-control ltr">{{ trDetail.card_holder_pan }}</div>
        </b-form-group>
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('transaction-details')"
        >بستن</b-button
      >
    </b-modal>
  </div>
</template>
<style>
.rtl {
  direction: rtl;
}
.ltr {
  direction: ltr;
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";
import persianDate from "../../helpers/persianDate";
export default {
  name: "transactions",
  data() {
    return {
      dataLoaded:false,
      gid: "",
      gateways: [],
      trDetail: { location: { countryCode: "IR" } },
      is_verify: false,
      ShowFilter: false,
      CardNumber: "",
      DateFrom: "",
      DateTo: "",
      SaleOrderId: "",
      transactions: [],
      pages: [],
      current_page: 1,
      page_count: 0,
      fields: [
        {
          key: "id",
          label: "شماره تراکنش",
        },
        {
          key: "website_name",
          label: "وبسایت",
        },
        {
          key: "persian_date",
          label: "تاریخ تراکنش",
        },
        {
          key: "is_verify",
          label: "وضعیت",
        },
        {
          key: "sale_reference_id",
          label: "کد رهگیری",
        },
        {
          key: "cost",
          label: "مبلغ",
        },
        {
          key: "title",
          label: "نام بانک",
        },
        {
          key: "verify_date",
          label: "تاریخ و ساعت تایید",
        },
        {
          key: "website_name",
          label: "وبسایت",
        },
        {
          key: "more_data",
          label: "عملیات",
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "درگاه های بانکی", route: "/gateways" },
      { title: "تراکنش های درگاه" },
    ]);
    httpHelper.setAuth();
    httpHelper
      .getData("paymentgateways")
      .then((response) => {
        this.gateways = response.result.map(function (o) {
          return {
            text: o.website_name,
            value: o.id,
          };
        });
      })
      .finally(() => {});
    if (this.$route.params.id != null) {
      this.gid = this.$route.params.id;
    }
    this.LoadData(1);
  },
  methods: {
    LoadData(page) {
      this.dataLoaded = false;
      const submitButton = this.$refs["filter_btn"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      var url =
        "transactions" +
        "?page=" +
        page +
        "&gid=" +
        this.gid +
        "&cardNumber=" +
        this.CardNumber +
        "&dateFrom=" +
        this.DateFrom +
        "&dateTo=" +
        this.DateTo +
        "&saleOrderId=" +
        this.SaleOrderId +
        (this.is_verify ? "&is_verify=1" : "");
      httpHelper.getData(url).then((res) => {
        this.dataLoaded = true;
        this.transactions = res.result.data;
        this.pages = [];
        this.current_page = res.result.current_page;
        var startPageer = this.current_page > 5 ? this.current_page - 4 : 0;
        var endPageer =
          res.result.last_page > 5
            ? this.current_page + 3
            : res.result.last_page;
        this.page_count = res.result.last_page;
        if (this.current_page + 3 > this.page_count) {
          endPageer = this.page_count;
        }
        for (let i = startPageer; i < endPageer; i++) {
          this.pages.push(i + 1);
        }
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      });
    },
    ShowDetail(id) {
      var url = "transactions?id=" + id;
      httpHelper.getData(url).then((res) => {
        this.trDetail = res.result;
        this.$bvModal.show("transaction-details");
      });
    },
    getDate(date) {
      var d = new Date(date);
      //persianDate.getTime(d);
      return persianDate.getDateByFormat(date);
    },
  },
  computed: {},
};
</script>